import React, { useState } from "react";
import contactUsData from "../../data/contact-us.json";
import emailjs from "emailjs-com";

export default function Contact({ bgColor }) {
  // State for form fields
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    status: "",
    message: "",
    hearAboutUs: "",
  });

  // State for participant list form
  const [participantEmail, setParticipantEmail] = useState("");
  const [participantAlert, setParticipantAlert] = useState({ show: false, type: "", message: "" });
  const [isParticipantLoading, setIsParticipantLoading] = useState(false);

  // State for loading and alert
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setAlert({ show: false, type: "", message: "" });

    // Send email using EmailJS
    emailjs
      .send(
        "service_zgh2ksd", // Replace with your EmailJS service ID
        "template_cokkqp7", // Replace with your EmailJS template ID
        formData,
        "USX72MTx26hcTNM95" // Replace with your EmailJS user/public key
      )
      .then(
        (response) => {
          setAlert({
            show: true,
            type: "success",
            message: "Your message has been sent successfully! We'll get back to you soon.",
          });
          setFormData({
            fullName: "",
            email: "",
            phone: "",
            status: "",
            message: "",
            hearAboutUs: "",
          });
        },
        (error) => {
          setAlert({
            show: true,
            type: "danger",
            message: "Failed to send message. Please try again or contact us directly.",
          });
        }
      )
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handle participant list submission
  const handleParticipantSubmit = (e) => {
    e.preventDefault();
    setIsParticipantLoading(true);
    setParticipantAlert({ show: false, type: "", message: "" });

    emailjs
      .send(
        "service_zgh2ksd",
        "template_cokkqp7",
        {
          email: participantEmail,
          status: "participant-list",
          message: "New participant list subscription",
        },
        "USX72MTx26hcTNM95"
      )
      .then(
        (response) => {
          setParticipantAlert({
            show: true,
            type: "success",
            message: "Thank you for joining our participant list!",
          });
          setParticipantEmail("");
        },
        (error) => {
          setParticipantAlert({
            show: true,
            type: "danger",
            message: "Failed to subscribe. Please try again.",
          });
        }
      )
      .finally(() => {
        setIsParticipantLoading(false);
      });
  };

  return (
    <>
      <section
        id="contact"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <div className="container">
          <div className="row">
            {alert.show && (
              <div className="col-12 pb-3">
                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                  {alert.message}
                  <button 
                    type="button" 
                    className="close" 
                    onClick={() => setAlert({ show: false, type: "", message: "" })}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            )}
            <div className="col-md-5">
              <div className="section-heading">
                <h2>{contactUsData.title}</h2>
                <p>{contactUsData.description}</p>
              </div>
              <div className="footer-address">
                <p>Clinic Location: {contactUsData.location}</p>
                <p>Phone: {contactUsData.phone}</p>
                <p>Email:{" "}
                      <a href={`mailto:${contactUsData.email}`}>
                         {contactUsData.email}
                      </a></p>
              </div>
              {/* Participant List Section */}
              <div className="participant-list-section mt-4">
                <div className="section-heading">
                  <h4 style={{marginTop:"3rem"}}>Join Our Participant List</h4>
                  <p className="mb-3">Stay updated with our latest clinical research opportunities and news.</p>
                </div>
                
                {participantAlert.show && (
                  <div className={`alert alert-${participantAlert.type} alert-dismissible fade show`} role="alert">
                    {participantAlert.message}
                    <button 
                      type="button" 
                      className="close" 
                      onClick={() => setParticipantAlert({ show: false, type: "", message: "" })}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}

                <form onSubmit={handleParticipantSubmit} className="participant-form">
                  <div className="form-group">
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        value={participantEmail}
                        onChange={(e) => setParticipantEmail(e.target.value)}
                        required
                        disabled={isParticipantLoading}
                      />
                      <div className="input-group-append">
                        <button 
                          type="submit" 
                          className="btn solid-btn" 
                          disabled={isParticipantLoading}
                        >
                          {isParticipantLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                              Joining...
                            </>
                          ) : (
                            "Join"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-7">
              <form onSubmit={handleSubmit} className="contact-us-form">
                <h5>Reach us quickly</h5>
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="fullName"
                        className="form-control"
                        placeholder="Full Name*"
                        required
                        value={formData.fullName}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        placeholder="Phone Number*"
                        required
                        value={formData.phone}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="form-group">
                      <select
                        name="status"
                        className="form-control"
                        required
                        value={formData.status}
                        onChange={handleChange}
                        disabled={isLoading}
                      >
                        <option value="" disabled>
                          You are a*
                        </option>
                        <option value="participant">Participant</option>
                        <option value="sponsor">Sponsor</option>
                        <option value="future-staff">Future Staff</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        className="form-control"
                        rows="7"
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange}
                        disabled={isLoading}
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="hearAboutUs"
                        className="form-control"
                        placeholder="How did you hear about us?"
                        value={formData.hearAboutUs}
                        onChange={handleChange}
                        disabled={isLoading}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 mt-3">
                    <button 
                      type="submit" 
                      className="btn solid-btn" 
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        contactUsData.button
                      )}
                    </button>
                  </div>
                </div>
              </form>
              <p className="form-message"></p>
            </div>
          </div>
        </div>
      </section>

      
    </>
  );
}
